export const activityConstants = {
  GET_ACTIVITY_UNREAD_COUNT_REQUEST: 'GET_ACTIVITY_UNREAD_COUNT_REQUEST',
  GET_ACTIVITY_UNREAD_COUNT_SUCCESS: 'GET_ACTIVITY_UNREAD_COUNT_SUCCESS',
  GET_ACTIVITY_UNREAD_COUNT_FAILURE: 'GET_ACTIVITY_UNREAD_COUNT_FAILURE'
};
